import { SPECIAL_LANGUAGES_FOR_INPUT_FIELDS } from '@entities/language/model/constants';

export const isRTL = (direction: string): boolean => {
  return direction === 'rtl';
};

export const getDirFromLocale = (locale: string): 'ltr' | 'rtl' => {
  return locale === 'ar' || locale === 'kr' ? 'rtl' : 'ltr';
};

export const checkSpecialLanguagesForInputFields = (language: string): boolean => {
  return SPECIAL_LANGUAGES_FOR_INPUT_FIELDS.includes(language);
};

export const isArabic = (locale: string): boolean => {
  return locale === 'ar';
};

export const isKurdish = (locale: string): boolean => {
  return locale === 'kr';
};

export const isEnglish = (locale: string): boolean => {
  return locale === 'en';
};

export const getLanguageName = (
  locale: string,
  languages: Array<{ lang: string; name: string }>
): string => {
  const language = languages.find((lang) => lang.lang === locale);
  return language?.name || 'English';
};

export const specialLanguagesForInputFields = SPECIAL_LANGUAGES_FOR_INPUT_FIELDS;
